export default __webpack_public_path__ + "static/media/ani-scale-2x.505768be.png";